<template>
    <div class="lm-border pa-2 pt-3 pb-3 v-flex" style="position: relative">
        <p-audit-modification
            style="    position: absolute;
    right: -78px;
    transform: rotate(90deg);
    font-size: 11px;
    top: 85px;text-align: left; width: 175px;height: 20px;color: grey"
            :entry = "entry"
        />
        <div class="catalogue-frequence black--text"  v-if="isAudit">
            {{ isMeasure ? frequence.name : '' }}
        </div>

        <div style="display: block; width: calc(100% - 30px)" class="pr-0" :class="isAudit ? '' : 'ml-3'">

            <div class="v-flex" style="">
                <div class="catalogue-id">
                    {{ entry.catalogue.id }}
                </div>

                <p-audit-rating
                    v-if        = "edit"
                    v-model     = "rating"
                    :show-no    = "!isCyberSecurity"
                    :inadequate = "entry.catalogue.inadequate && isAudit"
                    class       = "ml-2"
                />
                <div
                    v-if="!edit"
                    class="catalogue-type ml-2"
                    :class="typeColor"
                >
                    {{ entry.type.name }}
                </div>

                <v-spacer />
                <div  class="v-flex" v-if="(isAudit || isEsg) && isPlaner">
                    <div v-if="showBudgetData">
                        <c-toolbar-button
                            color    = "primary"
                            size     = "20"
                            :icon    = "edit ? 'mdi-content-save' : 'mdi-pencil'"
                            :tooltip = "edit ? 'Änderungen speichern' : 'Maßnahme bearbeiten'"
                            @click   = "onEdit"
                        />
                    </div>

                    <div class="ml-2" style="margin-top: 0">
                        <c-toolbar-button
                            v-if    = "edit"
                            color   = "primary"
                            size    = "28"
                            icon    = "mdi-close"
                            tooltip = "Bearbeitung ohne speichern beenden"
                            @click  = "onCancel"
                        />
                    </div>
                </div>
            </div>

            <v-divider class="mt-2 mb-2" />
            <div v-html="entryTitle">
            </div>

            <v-divider
                v-if="isCyberSecurity"
                class="mt-3"
            />

            <div class="primary--text mt-3" style="font-size: 11px; width: 100px;" v-if="(entry.measure && !edit) || (isCyberSecurity && entry.type.id === 1) ">
                Maßnahme
            </div>
            <div
                v-if="isCyberSecurity && entry.type.id === 1"
            >
                <div v-html="entry.catalogue.measures[0].description">
                </div>
                <v-divider class="mt-3" />
            </div>

            <div
                v-if="(entry.type.id === 2 || entry.type.id === 4 || rating === 2 || rating === 4) && entry.measure"
                class="mt-0 mb-3 lm-border pa-3 pt-2"
                style="position: relative"
            >
                <div class="v-flex mb-2" style="justify-content: center" v-if="isAudit">
                    <div>
                        <div class="primary--text" style="font-size: 9px; width: 100px; text-align: center">
                            Schwere
                        </div>
                        <div class="catalogue-weight lm-border"  v-if="isMeasure">
                            {{ weight.name }}
                        </div>
                    </div>

                    <div class="ml-2">
                        <div class="primary--text" style="font-size: 9px; width: 100px; text-align: center">
                            Risiko
                        </div>

                        <div class="catalogue-risk lm-border"  v-if="isMeasure">
                            {{ risk.name }}
                        </div>
                    </div>

                    <div class="ml-2">
                        <div class="primary--text" style="font-size: 9px; width: 100px; text-align: center">
                            Frist
                        </div>

                        <div class="catalogue-risk lm-border"  v-if="isMeasure">
                            {{ deadline ? deadline.name : '---' }}
                        </div>
                    </div>
                </div>

                <div class="mb-2" v-if="!edit">
                    {{ entryMeasure }}
                </div>

                <div v-if="edit"  class="mb-4 mt-4">
                    <v-select
                        v-model            = "entry.measure"
                        label              = "Maßnahme"
                        :items             = "measures"
                        item-value         = "id"
                        item-text          = "description"
                        :return-object     = "true"
                        :rules             = "[ requiredRule ]"
                        :hide-details      = "(entry.measure && !!entry.measure.id)"
                        :key               = "refreshMeasures"
                    >
                        <template v-slot:item="{ item }">
                            {{ measureText (item) }}
                        </template>
                        <template v-slot:selection="{ item }">
                            {{ measureText (item) }}
                        </template>
                    </v-select>
                </div>


                <v-row dense v-if="showBudgetData && (isAudit || isEsg)">
                    <v-col class = "col-6">
                        <v-switch
                            label     = "Maßnahme umgesetzt"
                            :ripple   = "false"
                            v-model   = "entry.done"
                            :readonly = "!edit"
                            hide-details
                        />
                    </v-col>
                    <v-col class = "col-6">
                        <c-inc-chooser
                            v-model = "entry.incidentId"
                            :unit   = "unit"
                            :edit   = "!entry.done"
                        />
                    </v-col>
                </v-row>

                <v-row dense class="mt-2" v-if="showBudgetData && (isAudit || isEsg)">
                    <v-col class="col-6">
                        <f-read-only-field
                            class  = "cost-rule"
                            :label = "$t('audit.costs.rule')"
                            :value = "costs (entry.measure)"
                            filled
                        />
                    </v-col>
                    <v-col class="col-6">
                        <f-currency-field-rw
                            v-model   = "entry.costs"
                            :label    = "$t('audit.costs.label')"
                            :readonly = "!edit"
                        />
                    </v-col>
                </v-row>
            </div>
            <div>
                <f-read-only-field
                    v-if   = "!edit"
                    class  = "mt-2"
                    label  = "Notiz"
                    :value = "entry.notice"
                    filled
                    dense
                />
                <v-textarea
                    v-if    = "edit"
                    label   = "Notiz"
                    class   = "mt-4"
                    v-model = "entry.notice"
                    rows    = "2"
                    hide-details
                    no-resize
                />
            </div>
        </div>

    </div>
</template>

<script>
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import FCurrencyFieldRw from "@/modules/core/components/utils/FCurrencyFieldRw.vue";
import Audit from "@/modules/audit/service/Audit";
import Core from "@/modules/core/service/Core";
import PAuditRating from "@/modules/audit/components/private/PAuditRating.vue";
import CIncChooser from "@/modules/inc/steps/components/common/CIncChooser.vue";
import PAuditModification from "@/modules/audit/components/private/PAuditModification.vue";

const EMPTY = {
    id  : null,
    name: null
};

export default {
    name: "PAuditCatalogEntry",
    components: {
        PAuditModification,
        CIncChooser,
        PAuditRating,
        FCurrencyFieldRw,
        CToolbarButton,
        FReadOnlyField
    },

    props: {
        auditId: {
            required: true
        },

        entry: {

        },

        unit: {

        },

        country: {

        },

        showBudgetData: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    data: () => ({
        edit: false,
        rating: false,
        refreshMeasures: 0,

        current: {
            done      : false,
            budgetYear: null,
            costs     : null,
            rating    : null,
        }
    }),

    computed: {
        entryTitle () {
            if (this.country && this.country === 'AT' && this.entry.catalogue.title_at) {
                return this.entry.catalogue.title_at;
            }

            return this.entry.catalogue.title;
        },

        entryMeasure () {
            return this.measureText(this.entry.measure);
        },

        measures () {
            return this.entry.catalogue.measures;
        },

        risk () {
            if (!this.entry.type || !this.entry.type.id) {
                return EMPTY;
            }

            switch (this.entry.type.id) {
                case 2: return this.entry.catalogue.risk;
                case 4: return this.entry.catalogue.riskInadequate;
            }

            return this.entry.catalogue.risk;
        },

        deadline () {
            if (!this.entry.type || !this.entry.type.id) {
                return EMPTY;
            }

            switch (!this.entry.type.id) {
                case 2: return this.entry.catalogue.deadline;
                case 4: return this.entry.catalogue.deadlineInadequate;
            }

            return this.entry.catalogue.deadline;
        },

        weight () {
            return this.entry.catalogue.weight;
        },

        frequence () {
            return this.entry.catalogue.frequence;
        },

        type () {
            return this.entry.type;
        },

        isMeasure () {
            if (!this.entry || !this.entry.type) {
                return null;
            }

            return this.entry.type.id === 2 || this.entry.type.id === 4 || this.rating === 2 || this.rating === 4;
        },

        isAudit () {
            return this.entry.catalogue.category.area === 'GBU'
        },

        isEsg () {
            return this.entry.catalogue.category.area === 'ESG'
        },

        isCyberSecurity () {
            return this.entry.catalogue.category.name === 'Cybersicherheit';
        },

        typeColor () {
            switch (this.type.id) {
                case 1: return "success white--text";
                case 2: return "error white--text";
                case 3: return "lm-border black--text";
                case 4: return "warning white--text";
            }

            return null;
        },

        unitData () {
            return this.$store.getters.site;
        },

        specification () {
            if (!this.unitData) {
                return null;
            }

            return this.unitData.specification;
        },

        typeOfDrive () {
            if (!this.specification) {
                return null;
            }

            if (!this.specification.typeOfDrive || !this.specification.typeOfDrive.id) {
                return null;
            }

            const tod = parseInt(this.specification.typeOfDrive.id);
            return (tod === 1 || tod === 2) ? "hyd" : "rope";
        },

        isPlaner () {
            return Core.security.isPlanner() || Core.security.isDispatcher();
        }
    },

    watch: {
        rating () {
            if (this.rating === 2) {
                this.entry.measure = Core.data.clone(this.measures[0]);
            }

            this.refreshMeasures++;
        }
    },

    methods: {
        measureText (measure) {
            if (this.country && this.country === 'AT' && measure.description_at) {
                return measure.description_at;
            }

            const rating = this.rating ? this.rating : this.entry.type.id;
            if (rating === 4 && measure.descriptionInadequate) {
                return measure.descriptionInadequate
            }

            return measure.description;
        },

        onEdit () {
            if (this.edit) {
                this.entry.type.id = this.rating;
                if (this.rating === 1 || this.rating === 3) {
                    this.entry.measure = null;
                }

                this.entry.type.name = this.$store.getters.audit.ratings [this.rating-1].name;
                Audit.save(this.auditId, this.entry).then (() => {
                    Core.message.alert.save(this);
                });
            } else {
                this.current.done       = this.entry.done;
                this.current.budgetYear = this.entry.budgetYear;
                this.current.costs      = this.entry.costs;
                this.current.rating     = this.entry.type.id;
                this.rating             = this.entry.type.id;
            }

            this.edit = !this.edit
        },

        onCancel () {
            this.edit = false;
            this.entry.done       = this.current.done;
            this.entry.budgetYear = this.current.budgetYear;
            this.entry.costs      = this.current.costs;
            this.entry.type.id    = this.current.rating;
        },

        requiredRule(value) {
            if (!value || value.length === 0 || !value.id) {
                return this.$t("common.required");
            }

            return true;
        },

        costs (measure) {
            if (!this.typeOfDrive) {
                return null;
            }

            let property = null;
            let absolute = null;
            let multiplier = null;

            switch (this.typeOfDrive) {
                case "rope":
                    property = measure.property;
                    absolute = measure.costsAbsolute1;
                    multiplier = measure.costMultiplier1;
                    break;
                case "hyd":
                    property = measure.property2;
                    absolute = measure.costsAbsolute2;
                    multiplier = measure.costMultiplier2;
                    break;
            }

            if (!property) {
                if (absolute) {
                    return 'Fester Betrag: ' + absolute + "€";
                }

                return "---";
            }

            if (!absolute || absolute === "0") {
                absolute = "";
            } else {
                absolute = absolute + "€ + "
            }

            if (property === 'mdoors') {
                return absolute + multiplier + "€ * (1 + Durchladung) "
            }

            if (property === 'entries') {
                return absolute + multiplier + "€ * " + (this.specification.entrypoints ? this.specification.entrypoints + " " : "" ) + "Zugangsstellen"
            }

            if (property === 'stops') {
                return absolute + multiplier + " € * " + (this.specification.stops ? this.specification.stops + " " : "" ) + "Haltestellen"
            }

            return null;
        }
    }
}
</script>

<style scoped>

.catalogue-id {
    font-size: 16px;
    font-weight: 700;
}

.catalogue-risk, .catalogue-weight, .catalogue-type {
    font-size: 14px;
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 4px;
    padding-top: 1px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.catalogue-risk, .catalogue-weight  {
    width: 100px;
}

.catalogue-type {
    min-width: 110px;
}

.catalogue-frequence {
    font-size: 14px;
    -ms-writing-mode: tb-lr;
    writing-mode: vertical-lr;
    transform: rotate(180deg);
    padding-top: 0;
    width: 24px;
    text-align: end;
    margin-left: -8px;
    margin-right: 6px;
    padding-bottom: 6px;
}

.cost-rule :deep(.readonly-value) {
    font-size: 12px;
    padding-top: 7px!important;
}

</style>